export const Prices = [
  {
    _id: 0,
    name: "Rs 0 to 500",
    array: [0, 500],
  },
  {
    _id: 1,
    name: "Rs 501 to 2000",
    array: [501, 2000],
  },
  {
    _id: 3,
    name: "Rs 2001 to 5000",
    array: [2001, 5000],
  },
  {
    _id: 4,
    name: "Rs 5001 to 8000",
    array: [5001, 8000],
  },
  {
    _id: 4,
    name: "Rs 8001 to 10000",
    array: [8001, 10000],
  },
  {
    _id: 5,
    name: "Rs 10000 and more",
    array: [10000, 1000000],
  },
];
